export default "__VITE_ASSET__Dn01YZqF__"